<template>
  <div class="panel">
    <div class="headerPanel">
      <HeaderPanel />
    </div>
    <div class="navbarPanel">
      <NavbarPanel />
    </div>
    <div class="mainRedemptions">
      <Redemptions />
    </div>
  </div>
</template>

<script>
import HeaderPanel from "@/components/panel/HeaderPanel";
import NavbarPanel from "@/components/panel/NavbarPanel";
import Redemptions from "@/components/panel/profitz/Redemptions";

export default {
  metaInfo() {
    return {
      title: "Resgates | Leveros Integra",
      meta: [
        {
          name: "description",
          content:
            "Acompanhe todos os resgates realizados pelos parceiros através da plataforma.",
        },
        { property: "og:title", content: "Resgates | Leveros Integra" },
        { property: "og:site_name", content: "Leveros Integra" },
        {
          property: "og:description",
          content:
            "Acompanhe todos os resgates realizados pelos parceiros através da plataforma.",
        },
        { name: "robots", content: "noindex,nofollow" },
      ],
    };
  },
  components: {
    HeaderPanel,
    NavbarPanel,
    Redemptions,
  },
};
</script>


<style lang="scss" scoped>
.panel {
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main";
  grid-template-columns: 0.7fr 3fr;

  @media (max-width: 440px) {
    grid-template-areas:
      "header header header"
      "main main main";
  }
}

.headerPanel {
  grid-area: header;
}

.navbarPanel {
  grid-area: navbar;
}

.mainRedemptions {
  grid-area: main;
}
</style>